'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardClientsCtrl', ['departments','$uibModal', 'clients', '$state', '$translate','Client','dialog','gridConfiguration','Authentication', require('./dashboardClientsCtrl')]);
app.config(['$stateProvider', require('./dashboardClientsConfig')]);
